import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactCommonmark from 'react-commonmark';
import translate from '../../services/translation';
import {AddFavouritesApp} from "../../apps/AddFavouritesApp";
import Slider from "react-slick";
import NumberFormat from 'react-number-format';
import PriceInformation from "../Planner/PriceInformation";
import LabelPopup from "./LabelPopup";

export default class ItineraryItem extends Component {

    static propTypes = {
        favouriteItem: PropTypes.object,
        onRemove: PropTypes.func,
        favouriteLink: PropTypes.string,
    };

    render() {
        const {favouriteItem, onRemove, favouriteLink} = this.props;

        return (
            <div className="favouriteItemWrapper">
                <div className="favouriteItemContainer">
                    <div className="favouriteItemRowImage">
                        {favouriteItem.travelarea &&
                            <span className="favouriteItemTravelarea">
                                {favouriteItem.travelarea}
                            </span>
                        }
                        <div className="favouriteItemImage">
                            <Slider dots={true}>
                                {favouriteItem.sliderUrls.map((url, index) => {
                                    return (<img alt="" key={index} src={url} />);
                                })}
                            </Slider>
                        </div>
                        <div className="favouriteItemMap">
                            <img alt="" src={favouriteItem.mapUrl}/>
                        </div>
                    </div>
                    <div className="favouriteItemRowText">
                        {favouriteItem.label.length > 0 && (
                            <LabelPopup labels={favouriteItem.label} />
                        )}

                        <AddFavouritesApp itineraryUid={favouriteItem.uid} favouriteType='itinerary' favouriteLink={favouriteLink}/>

                        {onRemove &&
                            <div className="favouriteItemRemove">
                                <button onClick={() => onRemove(favouriteItem.uid)}>
                                <span className="removeButtonText hiddenText">{translate('favourite.close')}</span>
                                    <span className="removeButtonIcon"/>
                                </button>
                            </div>
                        }

                        <div className="favouriteItemTextWrapper">
                            <a href={favouriteItem.detailPageUrl}>
                                <div className="favouriteItemHeadline">
                                    <h2>{favouriteItem.title}</h2>
                                </div>
                                <div className="favouriteItemTeaser">
                                    <p>{favouriteItem.teaser}</p>
                                </div>
                                <div className="favouriteItemText">
                                    {favouriteItem.description && <ReactCommonmark source={favouriteItem.description}/>}
                                </div>
                                <div className="favouriteItemInfo">
                                    <PriceInformation priceInformation={favouriteItem.priceInformation}/>

                                    {favouriteItem.duration !== 0 &&
                                        <div className="favouriteItemDuration">
                                            <span>{favouriteItem.duration} {translate('itinerary_item.days')}</span>
                                        </div>
                                    }

                                    {favouriteItem.price !== 0 ?
                                        <div className="favouriteItemPrice">
                                            <span className="fromPriceText">{translate('itinerary_item.from')}</span>
                                            <span className="fromPrice"><NumberFormat prefix={'Fr. '}
                                                                                      value={favouriteItem.price}
                                                                                      displayType='text'
                                                                                      thousandSeparator={"'"}
                                                                                      suffix={'.-'}/>
                                            </span>
                                            <span className="fromPriceInfo">{translate('itinerary_item.price_per_person')}</span>
                                        </div>
                                        :
                                        <span className="fromPriceInfo">{translate('itinerary_item.price_on_request')}</span>
                                    }

                                    {favouriteItem.serviceFeeText !== '' &&
                                        <div className="favouriteItemServiceFeeText">
                                            {favouriteItem.serviceFeeText}
                                        </div>
                                    }
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Favourites/ItineraryItem.js